<template>
  <section class="ProductBlocks" v-if="productBlocks">
    <div class="container">
      <!-- <ul>
        <li v-for="(block, key) in productBlocks" :id="'zblock' + key" :key="key">
          <div
            class="Product-menuTarget"
            :data-links="block.title"
            :id="block.title.replace(/[\s?-]/g, '')"
          ></div>
          <div
            class="Separator-title"
            v-text="block.title"
            :class="{ overrideMargin: overrideListArray.includes(block.content[0].type) }"
          />
          <div
            v-for="(content, contentKey) in block.content"
            :data-scroll="block.title.replace(/[\s?-]/g, '')"
            :key="contentKey"
            v-html="content.html"
          />
        </li>
      </ul> -->

      <ProductStrates />



    </div>

    <ProductInstallation />
    <!-- <div id="rs-plugin-settings-inline-css" /> -->
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import EventBus from "@/event-bus";
import "@/components/Product/ProductBlocks/ProductBlocks.scss";

import ProductStrates from "@/components/Product/ProductStrates/ProductStrates.vue";
import ProductInstallation from "@/components/Product/ProductInstallation/ProductInstallation.vue";

export default {
  name: "ProductBlocks",

  components: {
      ProductStrates,
      ProductInstallation
  },

  data() {
    return {
      scripts: [],
      lunchInsertHtml: [],
      overrideListArray: ["reinsurance", "slider_revolution"],
    };
  },

  computed: {
    ...mapGetters({ productBlocks: "getProductBlocks" })
  },

  mounted() {
    Object.values(this.productBlocks).forEach(block => {
      let script = block.script;
      var re = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
      var match;
      let endScript = [];
      while ((match = re.exec(script))) {
        // full match is in match[0], whereas captured groups are in ...[1], ...[2], etc.
        endScript.push(match[1]);
      }
      endScript.forEach(scriptFormated => {
        let script = document.createElement("script");
        script.text = scriptFormated;
        script.type = "text/javascript";
        document.body.appendChild(script);
      });
    });

    EventBus.$on("action-scroll", event => {
      let target = document.getElementById(event.target.getAttribute("data-id-target"));
      const appOffsetTop = document.getElementById("app").offsetTop;
      const adjustment = event.target.getAttribute("data-id-target") === "reviews" ? 320 : 0;

      window.scrollTo(0, target.offsetTop - 200 + appOffsetTop + adjustment);
    });
  },
};
</script>
